if ($(".type-detail").length) {

  renderRecentlyViewed();

  $(".p-info-wrapper").append("<div data-shopcode-doplnky></div>");

  // miniatura 100x100 z doplňků má okraje, takže zaoblení není vidět; originál má přirozený poměr stran
  function doplnkyNaturalImages() {
    $(".shopcode-doplnky__obrazek img").each(function () {
      const src = this.getAttribute("src") || "";
      if (src.indexOf("/related/") === -1) return;
      this.setAttribute("src", src.split("?")[0].replace("/related/", "/orig/"));
      this.removeAttribute("width");
      this.removeAttribute("height");
    });
  }
  const doplnkyEl = document.querySelector("[data-shopcode-doplnky]");
  if (doplnkyEl && typeof MutationObserver === "function") {
    new MutationObserver(doplnkyNaturalImages).observe(doplnkyEl, { childList: true, subtree: true });
  }

  // šipka u výběru varianty doplňků: otočená, dokud je select rozbalený
  $(document)
    .on("click", ".shopcode-doplnky__vyber", function () {
      this.classList.toggle("is-open");
    })
    .on("change blur", ".shopcode-doplnky__vyber", function () {
      this.classList.remove("is-open");
    })
    .on("keydown", ".shopcode-doplnky__vyber", function (e) {
      if (e.key === "Escape" || e.key === "Enter") this.classList.remove("is-open");
    });

  const RADKU_KAMARADI = 2;

  // vždy RADKU_KAMARADI řádky dlaždic, poslední dlaždicí je tlačítko "+ N dalších";
  // počet v řádku se mění podle šířky, tak ho změříme
  function upravKamarady(blok) {
    if (!blok.classList.contains("shopcode-kamaradi--detail")) return;
    ShopcodeKamaradi.zkrat(blok, 0); // 0 = všichni
    const polozky = blok.querySelectorAll(".shopcode-kamaradi__polozka");
    if (!polozky.length) return;
    let vRadku = 0;
    for (const p of polozky) {
      if (p.offsetTop !== polozky[0].offsetTop) break;
      vRadku++;
    }
    const mist = vRadku * RADKU_KAMARADI;
    if (polozky.length > mist) ShopcodeKamaradi.zkrat(blok, mist - 1);
  }
/*
  document.addEventListener("ShopcodeKamaradiVlozeny", function (e) {
    e.detail.bloky.forEach(function (b) {
      upravKamarady(b.prvek);
    });
  });*/

  //let kamaradiTimer;
 /* window.addEventListener("resize", function () {
    clearTimeout(kamaradiTimer);
    kamaradiTimer = setTimeout(function () {
      document.querySelectorAll(".shopcode-kamaradi").forEach(upravKamarady);
    }, 150);
  });*/

  if ($("#rate-form").length) {
    $(document).on(
      "click",
      "div.add-comment.rate-form-trigger button",
      function (e) {
        e.preventDefault();

        $.colorbox({
          inline: true,
          href: "#rate-form",
          width: "90%",
          height: "90%",
          maxWidth: "1000px",
          maxHeight: "622px",
          onComplete: function () {
            $.colorbox.resize();
            $("#rate-form").toggleClass("js-hidden");

          },
        });

        return false;
      },
    );
  }

  $(".p-info-wrapper").append($(".p-detail-inner-header").clone());
  $(".p-info-wrapper").append('<div class="customCart"></div>');
  $(".customCart").append($(".p-final-price-wrapper"));
  $(".customCart").append($(".add-to-cart"));

  if ($(".p-thumbnails").length) {
    const $thumbnails = $(".p-thumbnails a.p-thumbnail");
    const visibleThumbnails = 4;
    const hiddenCount = $thumbnails.length - visibleThumbnails;
    $thumbnails.each(function (index) {
      if (index >= visibleThumbnails) {
        $(this).addClass("hidden");
      }
      const $img = $(this).find("img");
      $img.attr(
        "data-src",
        $img.attr("data-src").replace("/related/", "/orig/"),
      );
    });
    if (hiddenCount > 0 && !$(".p-thumbnails-inner > div .more").length) {
      $(".p-thumbnails-inner > div").append(
        `<span class="more tss">+${hiddenCount} fotografií</span>`,
      );
      $(".p-thumbnails-inner > div .more.tss").on("click", function () {
        const $cbox = $(
          '.cbox-gal[href="' + $thumbnails.eq(visibleThumbnails).attr("href") + '"]',
        ).first();
        $cbox.trigger("click");
      });
    }
  }

  $(".btn.btn-lg.btn-conversion.add-to-cart-button").text("Do košíku");

  $(document).on("click", ".shp-tab-link", function (e) {
    e.preventDefault();
    var target = $(this).attr("href");
    // 1) aktivní tab class reset
    $(".shp-tab-link").removeClass("active");
    $(this).addClass("active");

    // 2) content switch
    $(".tab-content").removeClass("active");
    $(target).addClass("active");

    // 3) scroll (volitelné)
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top - 100,
      },
      200,
    );
  });

  $(".p-info-wrapper").append($(".shipping-options").clone());

  if ($(".parameter-dependent").length) {
    $(".parameter-dependent").each(function () {
      var $am = $(this).find(".availability-amount");
      if (!$am.length) {
        return;
      }
      $am.attr("style", $(this).find(".availability-label").attr("style"));
      $am.text($am.text().replace(/\(([^)]+)\)/, "$1"));
    });
  } else {
    $(".p-info-wrapper .availability-amount").attr(
      "style",
      $(".p-info-wrapper .availability-label").attr("style"),
    );
    $(".p-info-wrapper .availability-amount").text(
      $(".p-info-wrapper .availability-amount")
        .text()
        .replace(/\(([^)]+)\)/, "$1"),
    );
  }
   $(".p-info-wrapper").append('<div class="customStartCode"></div>')
  $(".p-info-wrapper .customStartCode").append($(".product-top .stars-wrapper").clone());

  if (
    $(".p-info-wrapper .stars-wrapper").length &&
    !$(".stars-wrapper > .p-code").length
  ) {
    var $code = $(".p-detail-inner > .p-detail-inner-header .p-code").first().clone();
    if ($code.length) {
      $(".customStartCode").append($code);
    }
  }

  if ($("#faq").length) {
    $("#p-detail-tabs").append(
      '<li class="shp-tab"><a href="#faq">FAQ</a></li>',
    );
    $("#tab-content").append($("#faq"));
    $("#faq").before(
      '<li class="faqb shp-tab ed added"><button >FAQ</button></li>',
    );
    $("li.faqb.shp-tab.ed.added button").on("click", function (e) {
      $("li.faqb.shp-tab.ed.added").toggleClass("open");
      $("#faq").toggleClass("open");
    });
  }
  if ($("#discussionWrapper").length) {

    $("#discussionWrapper").before(
      '<li class="disc shp-tab ed added"><button >Diskuze</button></li>',
    );
    $("li.disc.shp-tab.ed.added button").on("click", function (e) {
      $("li.disc.shp-tab.ed.added").toggleClass("open");
      $("#discussionWrapper").toggleClass("open");
    });
  }
  if ($("#ratingTab").length) {

    function isMobile() {
      return window.matchMedia("(max-width: 991px)").matches;
    }

    function getMobileScrollParent() {
      return document.querySelector('.content-wrapper')
        || document.querySelector('#page')
        || document.scrollingElement;
    }

    $(document).on('click', '.show-ratings', function (e) {
      e.preventDefault();

      const target = document.getElementById('ratingTab');
      if (!target) return;
      target.classList.add('open');
      const offset = 50;
      $('.ratetab').addClass('open');
      if (isMobile()) {
        // MOBILE (Shoptet wrapper scroll)
        const scrollParent = getMobileScrollParent();

        const parentRect = scrollParent.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();

        const top =
          targetRect.top -
          parentRect.top +
          scrollParent.scrollTop -
          offset;

        $(scrollParent).stop().animate({
          scrollTop: top
        }, 400);

      } else {
        // DESKTOP (window scroll)
        const top =
          target.getBoundingClientRect().top +
          window.pageYOffset -
          offset;

        $('html, body').stop().animate({
          scrollTop: top
        }, 400);
      }
    });

    $("#ratingTab").before(
      '<li class="ratetab shp-tab ed added"><button >Hodnocení</button></li>',
    );
    $("li.ratetab.shp-tab.ed.added button").on("click", function (e) {
      $("li.ratetab.shp-tab.ed.added").toggleClass("open");
      $("#ratingTab").toggleClass("open");
    });



  }
  if ($(".products-related").length) {
    $(".products-related-header").attr("id", "products-related-header");
    $("#p-detail-tabs").append(
      '<li class="shp-tab"><a href="#products-related-header">Související produkty</a></li>',
    );

    $(".shp-tabs-wrapper #tab-content").append(
      '<li class="related shp-tab rp added"><button >Související produkty</button></li>',
    );

    var initialized = false;
    var $slider = $(".products-related");

    $("li.related.shp-tab.rp.added button").on("click", function () {
      $("li.related.shp-tab.rp.added").toggleClass("open");
      $(".products-related-header").toggleClass("open");
      $(".products-related").toggleClass("open");

      if (!initialized) {
        $slider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode: false,
          autoplay: false,
          autoplaySpeed: 5000,
          dots: true,
          arrows: true,
          infinite: false,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: { slidesToShow: 3, slidesToScroll: 1 },
            },
            {
              breakpoint: 991,
              settings: { slidesToShow: 2, slidesToScroll: 1 },
            },
            {
              breakpoint: 550,
              settings: {
                slidesToShow: 1,
                variableWidth: true,
              },
            },
          ],
        });
        initialized = true;
      } else {
        setTimeout(() => {
          $slider.slick("setPosition");
        }, 50);
      }
    });

    if (window.innerWidth >= 992) {
      if (!$slider.hasClass("slick-initialized")) {
        $slider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode: false,
          autoplay: false,
          dots: true,
          arrows: true,
          infinite: false,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: { slidesToShow: 3, slidesToScroll: 1 },
            },
          ],
        });
      }
    }
  }

  if ($(".slozeni").length) {
    $(".description-inner").append($(".slozeni").clone().attr("id", "slozeni"));
    $("#slozeni").before(
      '<li class="slozeni shp-tab ed added"><button >Složení & Péče</button></li>',
    );
    $("#p-detail-tabs").append(
      '<li class="shp-tab"><a href="#slozeni">Složení & Péče</a></li>',
    );

    $("li.slozeni.shp-tab.ed.added button").on("click", function (e) {
      $("li.slozeni.shp-tab.ed.added").toggleClass("open");
      $("#slozeni").toggleClass("open");
    });
  }

  $('li[data-testid="tabDescription"] a').on("click", function (e) {
    $('li[data-testid="tabDescription"]').toggleClass("open");
    $(".basic-description").toggleClass("open");
    $(".extended-description").toggleClass("open");
  });

  $(".extended-description>h3:first").text("Technické parametry");
  $(".basic-description>h3:first").text("Popis produktu");

  const rating = $(".p-info-wrapper .stars-wrapper .sr-only")
    .text()
    .match(/\d+,\d+/)[0];
  $(".p-info-wrapper .stars-wrapper .sr-only").text(rating);

  $("html").on("click", ".p-thumbnail:not(.video-thumb)", function (e) {
    e.preventDefault();
    let $cbox;
    const href = $(this).attr("href");
    $cbox = $('.cbox-gal[href="' + href + '"]').first();
    if ($cbox && $cbox.length) {
      $cbox.trigger("click");
    }
  });
}
